 const tasks = [
    {
        id: "1",
        task: "Make Maple falvored coffee",
        category: "inbox",
        status: false,
        tags :["work", "food"],
        date: new Date('December 17, 2021 03:24:00'),
        project: {name: "Cooking", order: 1},
        note: "Use Tim Hortons cofeee in the upper shelf",
        userId: "007",
        createdOn: "timestamp"
    },
    {
        id: "2",
        task: "Make French Omelette",
        category: "next",
        status: false,
        tags :["home", "food"],
        date: new Date('December 18, 2021 03:24:00'),
        project: {name: "Cooking", order: 2},
        note: "Use lots of cheese and just call it french",
        userId: "007",
        createdOn: "timestamp"
    },
    {
        id: "3",
        task: "Call Mom",
        category: "next",
        status: false,
        tags :["home", "phone"],
        date: null,
        project: {name: "default", priority: null},
        note: "Use lots of cheese and just call it french",
        userId: "007",
        createdOn: "timestamp"
    },
     {
        id: "4",
        task: "Email Plumber",
        category: "next",
        status: false,
        tags :["home", "email"],
        date: null,
        project: {name: "default", priority: null},
        note: "Ask for inspection charges",
        userId: "007",
        createdOn: "timestamp"
    },
      {
        id: "5",
        task: "Make presentation on Clean energy",
        category: "next",
        status: false,
        tags :["work", "email"],
        date: null,
        project: {name: "default", priority: null},
        note: "Include green energy options locallly available",
        userId: "007",
        createdOn: "timestamp"
    },
     {
        id: "6",
        task: "Order Printer cartridge",
        category: "next",
        status: false,
        tags :["work", "email"],
        date: null,
        project: {name: "default", priority: null},
        note: "Model no. EP-S101",
        userId: "007",
        createdOn: "timestamp"
    },
    {
        id: "7",
        task: "Do a furniture review",
        category: "next",
        status: false,
        tags :["work", "email"],
        date: null,
        project: {name: "default", priority: null},
        note: "All desk kept in meeting rooms",
        userId: "007",
        createdOn: "timestamp"
    },
    {
        id: "8",
        task: "Go to Bahamas",
        category: "someday",
        status: false,
        tags :["home"],
        date: null,
        project: {name: "default", priority: null},
        note: "Can you sail across Atlantic",
        userId: "007",
        createdOn: "timestamp"
    },
    {
        id: "9",
        task: "Buy new iphone",
        category: "someday",
        status: false,
        tags :["home"],
        date: null,
        project: {name: "default", priority: null},
        note: "The one with the night camera",
        userId: "007",
        createdOn: "timestamp"
    },
     {
        id: "10",
        task: "Call for TV repair",
        category: "inbox",
        status: false,
        tags :["home"],
        date: null,
        project: {name: "default", priority: null},
        note: "or maybe I should just let the TV die?",
        userId: "007",
        createdOn: "timestamp"
    },
]

export default tasks


// Name: string
// Description?: string
// Note: string
// Category/ Main folders - inbox, next, someday/maybe, deleted. Only one folder.: string
// Status- pending, completed. It is either done or not done.: boolean
// Tags? Personal tags as work, home, phone, priority 1, 2,3 etc. : array
// Timestamp: date()
// Schedule date. - how does input schedule work.:date()
// Project- ordered list: object {project id, project name, project order}
// authorId: 
// authorName: 